import { inject, Injectable } from '@angular/core';
import { CookieHelperService, LoggingService } from '@com-delta-idp/mnx-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { PkceCode } from '../../../models';
import { DashboardResponse } from '../../../session';
import { LoginRememberMeUtilsService } from '../login-remember-me-utils-service/login-remember-me-utils.service';
import { LoginRememberMeWrapperService } from '../login-remember-me-wrapper-service/login-remember-me-wrapper.service';
import { UserDataService } from './user-data.service';

@Injectable({
  providedIn: 'root'
})
export class UserSessionHelperExtendedService {
  protected userData = inject(UserDataService);
  protected loginRememberMeWrapper = inject(LoginRememberMeWrapperService);
  protected logging = inject(LoggingService);
  protected loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  protected cookieHelper = inject(CookieHelperService);
  protected data$!: Observable<DashboardResponse>;

  pkceCode = {} as PkceCode;
  tokenAvailable = false;
  tokenExpiry = 0;
  tokenIssuedTime = 0;
  tokenValue$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  removeSessionValues(): void {
    if (
      window.localStorage.getItem('uid') ||
      window.localStorage.getItem('encyToken') ||
      this.cookieHelper.getCookieValue('accountType')
    ) {
      window.localStorage.removeItem('uid');
      window.localStorage.removeItem('encyToken');
      this.cookieHelper.setCookieName('accountType', '', 0, false);
    }
  }
}
